/* eslint-disable import/prefer-default-export */
import React, { useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { getDefaultOptions, getDefaultUrl } from './campaign-fetch-config';

export const CampaignFetchContext = React.createContext({});

export const CampaignFetchProvider = ({ url, options, children }) => {
  const serverContext = useContext(ServerContext);
  let finalUrl = url || getDefaultUrl(serverContext);
  finalUrl = finalUrl.replace(/\/+$/, '');

  const instrumentation = useContext(InstrumentationContext);
  const finalOptions = getDefaultOptions(serverContext, instrumentation);

  if (options && options.headers) {
    finalOptions.headers = { ...finalOptions.headers, ...options.headers };
  }

  return (
    <CampaignFetchContext.Provider value={{
      url: finalUrl,
      options: finalOptions,
    }}
    >
      {children}
    </CampaignFetchContext.Provider>
  );
};
